import MediaPlanBody from './MediaPlanBody';

export default MediaPlanBody;
